export function ComingSoon() {
  return (
    <div className="w-full max-w-defaultMax h-full tracking-wider flex flex-col justify-center items-center text-center m-auto px-10 py-40">
      <h2 className="text-header4 sm:text-header3 font-ChronicleDisplayLight mb-6">
        COMING SOON
      </h2>
      <p>
        We are currently working on this page and we&apos;ll have it up and
        running soon!
        <br className="hidden md:block" />
        <span>
          In the meantime, feel free to explore the other pages in our website.
        </span>
      </p>
    </div>
  );
}

export default ComingSoon;
